import { InterfaceConfig, AmplifyConfig } from "@interfaces/response";

export const interfaceConfig: InterfaceConfig = {
  name: "avanza_solido",
  interest_rate: 30,
  textos_tofu: {
    pm: {
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo:
          "En caso de tener mas de un accionista en igualdad de acciones, \ningresar al que además funja como Representante Legal",
      },
    },
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: [
    "Avanza Solido SA de CV, SOFOM ENR",
    "Cumplo y Avanzo SAPI de CV, SOFOM ENR",
    "Lendit Group SAPI de CV",
  ],
  scripts: {
    tag_id_hotjar: "6487607",
    tag_id_google: "",
    tag_id_linkedin: "",
    tag_id_meta_pixel: "",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_k3I2MPdol",
      userPoolClientId: "42thusp2dfnk9j211mmscvtp84",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Usx5xKDDn",
      userPoolClientId: "vvta97uqr6l5eqke0ajeu24r4",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
